import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import BlogCategoryManager from "../components/BlogCategoryManager";

const BlogCategoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Manage Blog Category' />

        <BlogCategoryManager />

      </MasterLayout>
    </>
  );
};

export default BlogCategoryPage;
